import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Language } from "../reportMetaData/reportMetaDataHelper";

export class EmailHelper {
    public static getParameters = (query: string): Parameter[] => {
        let params: RegExpMatchArray | string[] = ((query || "").match(/(@[A-Za-z0-9_]+|\{{3}[A-Za-z0-9_]+\}{3})/gm));
        if (!Helper.hasValue(params))
            params = [];
        params = params.map((p: string, index: number) => {
            let arr = query.split(p);
            let str1 = "";
            let str2 = "";
            for (let i = 0; i < arr.length; i++) {
                if (i <= index) {
                    str1 += arr[i];
                } else {
                    str2 += arr[i];
                }
            }
            if (EmailHelper.hasEvenAmountOfChars(str1, "'") && EmailHelper.hasEvenAmountOfChars(str2, "'")) {
                return p;
            } else {
                return "";
            }
        });

        const parameters: Parameter[] = params.filter(f => EmailHelper.getName(f).length > 0).map((param: string) => {
            return {
                name: param,
                value: null
            }
        });
        return parameters;
    }

    public static getName = (value: string): string => {
        return value.replace("@", "").replace("{{{", "").replace("}}}", "").toLowerCase();
    }

    public static hasEvenAmountOfChars = (value: string, char: string): boolean => {
        const regEx = new RegExp(`${char}`, "gm");
        const count = (value.match(regEx) || []).length;
        return (count % 2 == 0);
    }

    public static loadPossibleParameters = (): Promise<{}> => {
        return new Promise<{}>(async (resolve) => {
            let result = await EmailHelper.loadData("email_dataSource_editor_parameters", () => { return HTTPService.get("EmailSender/GetPossibleParameters") })
            resolve(result)
        });
    }

    public static loadLanguages = (): Promise<Language[]> => {
        const func = async () => {
            const data = await HTTPService.get<JsonResultClass<Language[]>>("EditIndividualFields/GetLanguages");
            if (data.Code == 0) {
                return data.Data;
            } else {
                return [];
            }
        }

        return new Promise<Language[]>(async (resolve) => {
            let result = await EmailHelper.loadData("email_languages", func);
            resolve(result)
        });
    }

    public static loadData = <T extends any = any>(key: string, fallback: () => T): Promise<T> => {
        return new Promise<T>((resolve) => {
            const loadData = async () => {
                const data = await fallback();
                Helper.saveDataToStorage(key, data, false);
                Helper.saveDataToStorage(`${key}_timestamp`, new Date().getTime(), false);
                resolve(data);
            }
            const stampNow = new Date().getTime();
            const stampData: number = Helper.getValueOrDefault(Helper.loadDataFromStorage(`${key}_timestamp`), stampNow);
            const dif = (Math.abs(stampNow - stampData) / 36e5);
            const data = Helper.loadDataFromStorage(key);
            if (Helper.hasValue(data) && (dif < 4)) {
                resolve(data);
            } else {
                loadData();
            }
        })
    }

}

export interface Parameter {
    name: string;
    value: string | number;
}